import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgGuacModeVerified',
})
export default class CmgGuacModeVerified extends Vue {
  get guacmodeBadgeImageUrl(): string {
    return this.$appStore.state.cms.images.icons.guacModePepperBadge.default;
  }
}
